var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "27px",
    viewBox: "0 0 24 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-47.000000, -368.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043E\\u0435\\u0434\\u0438\\u043D\\u0435\\u043D\\u0438\\u044F",
    transform: "translate(39.000000, 348.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0422\\u0432\\u0438\\u0447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitch",
    transform: "translate(8.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.30103806,-4.84945417e-13 L23.0934256,-4.84945417e-13 L23.0934256,15.3146067 L14.6366782,23.7865169 L10.083045,23.7865169 L7.48096886,26.3932584 L4.87889273,26.3932584 L4.87889273,23.7865169 L0.0292733564,23.7865169 L1.03561604e-12,4.23595506 L1.30103806,-4.84945417e-13 Z M21.5640138,13.7303371 L21.5640138,2 L4,2 L4,17.3146067 L8.87889273,17.3146067 L8.87889273,20.5730337 L12.1314879,17.3146067 L17.9861592,17.3146067 L21.5640138,13.7303371 Z M15,7 L17.2768166,7 L17.2768166,13.5168539 L15,13.5168539 L15,7 Z M9,7 L11.2768166,7 L11.2768166,13.5168539 L9,13.5168539 L9,7 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.85096ef1c31dfd4a7b588216fb483e0a.svg";
export { ForwardRef as ReactComponent };